import { render, staticRenderFns } from "./DCItemsToDeliverView.vue?vue&type=template&id=748ab19e&"
import script from "./DCItemsToDeliverView.vue?vue&type=script&lang=js&"
export * from "./DCItemsToDeliverView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports